import { TypedDocumentNode } from 'apollo-angular';
import {
  TnOrderResponse,
  TnReserveResponse,
} from '@nuso/cpaas/types';
import { gql } from 'graphql-tag';

export const tnReserve: TypedDocumentNode<{ tnReserveResponse: TnReserveResponse }> = gql`
  mutation tnReserve($input: TnReserveInput!) {
    tnReserve(input: $input) {
      tnsReserved
      tnsNotReserved {
        tn
        reason
      }
      tnE164sReserved
      tnE164sNotReserved {
        tnE164
        reason
      }
    }
  }
`;

export const tnRelease = gql`
  mutation tnRelease($input: TnReleaseInput!) {
    tnRelease(input: $input) {
      tnsReleased
      tnsNotReleased {
        tn
        reason
      }
      tnE164sReleased
      tnE164sNotReleased {
        tnE164
        reason
      }
    }
  }
`;

export const tnOrder: TypedDocumentNode<{ tnOrder: TnOrderResponse}> = gql`
  mutation tnOrder($input: TnOrderInput!) {
    tnOrder(input: $input) {
      orderId
      tnOrder {
        id
        accountId
        pon
        status
        createdAt
        updatedAt
      }
      tnsOrdered
      tnsNotOrdered
      tnE164sOrdered
      tnE164sNotOrdered
    }
  }
`;

export const tnModifyTns = gql`
  mutation tnModifyTns($input: TnModifyOrderInput!) {
    tnModifyTns(input: $input) {
      orderId
    }
  }
`;

export const tnModifyAccountTns = gql`
  mutation tnModifyAccountTns($input: TnModifyAccountOrderInput!) {
    tnModifyAccountTns(input: $input) {
      orderId
    }
  }
`;

export const tnDisconnectTnsMultiAccount = gql`
  mutation tnDisconnectTnsMultiAccount($input: TnDisconnectOrderInput!) {
    tnDisconnectTnsMultiAccount(input: $input) {
      orderId
    }
  }
`;

export const tnDeleteTnsMultiAccount = gql`
  mutation tnDeleteTnsMultiAccount($input: TnDeleteOrderInput!) {
    tnDeleteTnsMultiAccount(input: $input) {
      orderId
    }
  }
`;

export const tnReactivateTns = gql`
  mutation tnReactivateTns($input: TnModifyAccountOrderInput!) {
    tnReactivateTns(input: $input) {
      orderId
    }
  }
`;

export const cpaasTnsChangeCustomer = gql`
  mutation cpaasTnsChangeCustomer($input: CpaasTnChangeCustomerInput!) {
    cpaasTnsChangeCustomer(input: $input) {
      id
      did
      customerId
      subAccountId
      subAccountName
      updatedAt
    }
  }
`;
